import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStatus } from "@/lib/queries";

/** Full-screen loading splash used while auth/bootstrap queries resolve. */
export function FullScreenSpinner() {
  return (
    <div className="flex h-dvh items-center justify-center bg-background">
      <Loader2 className="size-6 animate-spin text-muted-foreground" />
    </div>
  );
}

/**
 * Guards the admin area: redirects to /setup when no admin exists yet and to
 * /login when unauthenticated.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { data, isLoading, isError } = useAuthStatus();
  const location = useLocation();

  if (isLoading) return <FullScreenSpinner />;
  if (isError || !data) {
    return (
      <div className="flex h-dvh flex-col items-center justify-center gap-2 bg-background text-sm text-muted-foreground">
        <p>Cannot reach the Vigil server.</p>
        <p>Check that the backend is running, then reload.</p>
      </div>
    );
  }
  if (data.needsSetup) return <Navigate to="/setup" replace />;
  if (!data.authenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}
